import { render, staticRenderFns } from "./EmptySection.vue?vue&type=template&id=1dec8850&scoped=true&"
import script from "./EmptySection.vue?vue&type=script&lang=js&"
export * from "./EmptySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec8850",
  null
  
)

export default component.exports